// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 669) return "js/page-mainpage.js";
	if (chunkId === 574) return "js/page-aboutus.js";
	if (chunkId === 803) return "js/page-camps.js";
	if (chunkId === 411) return "js/page-gallery.js";
	if (chunkId === 769) return "js/page-videoteka.js";
	if (chunkId === 230) return "js/page-specific-camps.js";
	if (chunkId === 552) return "js/page-camp.js";
	if (chunkId === 399) return "js/page-reservation.js";
	if (chunkId === 879) return "js/page-forparents.js";
	if (chunkId === 698) return "js/page-opinions.js";
	if (chunkId === 309) return "js/page-contact.js";
	if (chunkId === 823) return "js/page-blog.js";
	if (chunkId === 551) return "js/page-article.js";
	if (chunkId === 593) return "js/page-discounts.js";
	if (chunkId === 261) return "js/page-faq.js";
	if (chunkId === 920) return "js/page-team.js";
	if (chunkId === 72) return "js/page-terms.js";
	if (chunkId === 753) return "js/page-insurance.js";
	if (chunkId === 83) return "js/page-cookies-policy.js";
	if (chunkId === 710) return "js/page-privacy.js";
	if (chunkId === 328) return "js/page-resort.js";
	if (chunkId === 71) return "js/page-whywithus.js";
	if (chunkId === 377) return "js/page-equipment.js";
	if (chunkId === 130) return "js/page-transport.js";
	if (chunkId === 329) return "js/datepicker.js";
	// return url for filenames based on template
	return undefined;
};